import {AiOutlineInstagram} from 'react-icons/ai'
import {AiOutlineTwitter} from 'react-icons/ai'
import { RiLinkedinFill } from 'react-icons/ri'
import {AiFillGithub} from 'react-icons/ai'


const data = [
    {
        id : 1,
        link : 'https://www.instagram.com/saipranav12/',
        icon: <AiOutlineInstagram/>
    },
    {
        id : 2,
        link : 'https://twitter.com/SaiPranav2004',
        icon : <AiOutlineTwitter/>
    },
    {
        id :3 ,
        link : 'https://www.linkedin.com/in/sai-pranav-mallineni-250796264',
        icon : <RiLinkedinFill/>
    },
    {
        id :4 ,
        link : 'https://github.com',
        icon : <AiFillGithub/>
    }
]

export default data